module.exports = __webpack_public_path__ + "img/ic-instagram.481bc9d7.svg";